import React, { useState, useEffect } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import api from "assets/services/api";


function ModalValidateStorage(props) {
    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);

    useEffect(() => {
        if(controlSnack) showNotification("br")
    }, [controlSnack])

    
    async function handleValidateMessage(e) {
        e.preventDefault();
        const response = await api.put('/message/' + props.props.type + '/resolve/' + props.props.id, {
        });
        if (response.status === 200) {
            setControlSnack(true);
            if(props.props.type === "sell"){
                props.getMessagesofSell();
            }else{
                props.getMessagesofStorage();
            }
            props.onHide();
        }
    }

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Validar mensagem
          </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleValidateMessage}>
                <Modal.Body>
                    <h4> Tem certeza que deseja validar esse mensagem?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Validar
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Mensage validado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalValidateStorage;